import { useState, useContext } from 'react';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Avatar, Box, Grid, Menu, MenuItem, Typography } from '@mui/material';

// project imports

// types
import PropTypes from 'prop-types';

// assets
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import GetAppTwoToneIcon from '@mui/icons-material/GetAppOutlined';
import FileCopyTwoToneIcon from '@mui/icons-material/FileCopyOutlined';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfOutlined';
import ArchiveTwoToneIcon from '@mui/icons-material/ArchiveOutlined';
import { currencyFormatter } from './Utils';
import SchoolFeeUi from "./Skeleton/SchoolFeeUi";
import MainCard from "./MainCard";
import { toTitleCase } from '../post_login/summary';

const CardWrapper = styled(MainCard)(({ theme }) => ({
   backgroundColor: "#FFFBEF",
    color: '#dc6',
    overflow: 'hidden',
    position: 'relative'
}));

// ===========================|| DASHBOARD DEFAULT - EARNING CARD ||=========================== //

const SchoolFeeCard = ({ isLoading, border, cardData }) => {
    const theme = useTheme();

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            {isLoading ? (
                <SchoolFeeUi />
            ) : (
                <CardWrapper border={border} content={false}>
                    <Box sx={{ p: 2.25 }}>
                        <Grid container direction="column">
                            <Grid item  alignItems="center">
                                    <Grid item  alignItems="center">
                                    <Typography variant="h6" gutterBottom color='#4c4c4c' align='center' sx={{ fontWeight:'700', fontSize: '1.6rem', fontWeight: 700, mt: 1.75 }}>
                                            { toTitleCase( cardData.TYPE == "SCHOOL" ? "School Fees" : cardData.TYPE )}
                                        </Typography>
                                        <Typography variant="h6" gutterBottom color="#8d8686" align='center' sx={{ fontSize: '1.9rem', fontWeight: 700, mb: -0.75}}>
                                            KES
                                        </Typography>
                                        <Typography color="#8d8686" align='center' sx={{ fontSize: '1.8rem', fontWeight: 700,  mb: 0.75 }}>
                                            { currencyFormatter(cardData.TOTAL_AMOUNT) } 
                                        </Typography>
                                </Grid>
                            </Grid>
                            <Grid alignItems="center" item sx={{ mb: 1.25 }} >
                                <Typography
                                align="center"
                                    sx={{
                                        fontSize: '1.6rem',
                                        fontWeight: 700,
                                        color: '#dfb22b'
                                    }}
                                >
                                    Show more
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </CardWrapper>
            )}
        </>
    );
};

SchoolFeeCard.propTypes = {
    isLoading: PropTypes.bool
};

export default SchoolFeeCard;